var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 25.375L18.85 19.575C17.6416 18.6688 16.1312 18.125 14.5 18.125C12.8687 18.125 11.3583 18.6688 10.15 19.575L14.5 25.375ZM14.5 3.625C9.6062 3.625 5.08703 5.24417 1.44995 7.975L3.62495 10.875C6.64578 8.60333 10.4158 7.25 14.5 7.25C18.5841 7.25 22.3541 8.60333 25.375 10.875L27.5499 7.975C23.9129 5.24417 19.3937 3.625 14.5 3.625ZM14.5 10.875C11.2375 10.875 8.2287 11.9504 5.79995 13.775L7.97495 16.675C9.78745 15.3096 12.047 14.5 14.5 14.5C16.9529 14.5 19.2125 15.3096 21.025 16.675L23.2 13.775C20.7712 11.9504 17.7625 10.875 14.5 10.875Z",
    fill: "#6B51EF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.90c385237568bd1068a71456f0d127d4.svg";
export { ForwardRef as ReactComponent };